import { render, staticRenderFns } from "./requireList.vue?vue&type=template&id=4b9027e4&scoped=true&"
import script from "./requireList.vue?vue&type=script&lang=js&"
export * from "./requireList.vue?vue&type=script&lang=js&"
import style0 from "./requireList.vue?vue&type=style&index=0&id=4b9027e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9027e4",
  null
  
)

export default component.exports